module.exports = __webpack_public_path__ + "img/Logo-Moment-Lawn-blanco.bc8859b2.png";